import type { ReactNode, VFC } from 'react';

import classNames from 'classnames';

import * as styles from './Description.module.scss';

interface DescriptionProps {
  description: ReactNode;
  className?: string;
}

const Description: VFC<DescriptionProps> = ({ description, className }) => {
  return (
    <div className={classNames(styles.assetDescription, className)}>
      {description}
    </div>
  );
};

export { Description };
